import { PayloadCaseTableViewResultType } from 'app/area/case-report/case-table-view/types-store';
import { FavouriteLayoutModel } from 'app/types-shared';

export const ACTION = {
  REQUEST_CASE_VIEW_TABLE: 'CASE_VIEW_TABLE:REQUEST',
  REPLACE_CASE_VIEW_TABLE: 'CASE_VIEW_TABLE:REPLACE',
  APPEND_CASE_VIEW_TABLE: 'CASE_VIEW_TABLE:APPEND',
  FAIL_EXECUTE_FAVOURITE_CASE_VIEW_TABLE: 'CASE_VIEW_TABLE:FAIL_EXECUTE_FAVOURITE',
  CLEAR_CASE_VIEW_TABLE: 'CASE_VIEW_TABLE:CLEAR',
  REMOVE_ITEM_CASE_VIEW_TABLE: 'CASE_VIEW_TABLE:REMOVE_ITEM',
  REQUEST_REMOVE_ITEM_CASE_VIEW_TABLE: 'CASE_VIEW_TABLE:REQUEST_REMOVE_ITEM',
  REQUEST_SINGLE_SUPPLIER_URL_CASE_VIEW_TABLE: 'CASE_VIEW_TABLE:REQUEST_SINGLE_SUPPLIER_URL',
  RECEIVE_SINGLE_SUPPLIER_URL_CASE_VIEW_TABLE: 'CASE_VIEW_TABLE:RECEIVE_SINGLE_SUPPLIER_URL',
  REQUEST_LAYOUT_MODEL: 'CASE_VIEW_TABLE:REQUEST_LAYOUT_MODEL',
  RECEIVE_LAYOUT_MODEL: 'CASE_VIEW_TABLE:RECEIVE_LAYOUT_MODEL'
};

export type RequestCaseViewTableActionType = {
  type: typeof ACTION.REQUEST_CASE_VIEW_TABLE;
  payload: {
    instanceKey: string;
  };
}

export interface CaseViewTableResultReplaceActionType {
  type: typeof ACTION.REPLACE_CASE_VIEW_TABLE;
  payload: PayloadCaseTableViewResultType;
}

export interface CaseViewTableResultAppendActionType {
  type: typeof ACTION.APPEND_CASE_VIEW_TABLE;
  payload: PayloadCaseTableViewResultType;
}

export interface FailExecuteFavouriteActionType {
  type: typeof ACTION.FAIL_EXECUTE_FAVOURITE_CASE_VIEW_TABLE;
  payload: {
    instanceKey: string;
    errorsExecuteFailed: string[];
    requestId?: number;
  };
}

export interface CaseViewTableClearActionType {
  type: typeof ACTION.CLEAR_CASE_VIEW_TABLE;
  payload: {
    instanceKey: string;
  };
}

export interface CaseViewTableRequestRemoveItemActionType {
  type: typeof ACTION.REQUEST_REMOVE_ITEM_CASE_VIEW_TABLE;
  payload: {
    instanceKey: string;
    caseId: number;
  };
}

export interface CaseViewTableRemoveItemActionType {
  type: typeof ACTION.REMOVE_ITEM_CASE_VIEW_TABLE;
  payload: {
    instanceKey: string;
    caseId: number;
  };
}

export interface CaseViewTableRequestSingleSupplierUrlActionType {
  type: typeof ACTION.REQUEST_SINGLE_SUPPLIER_URL_CASE_VIEW_TABLE;
  payload: {
    instanceKey: string;
  };
}
export interface CaseViewTableReceiveSingleSupplierUrlActionType {
  type: typeof ACTION.RECEIVE_SINGLE_SUPPLIER_URL_CASE_VIEW_TABLE;
  payload: {
    instanceKey: string;
    singleSupplierUrl: string;
  };
}

export interface CaseViewTableRequestLayoutModelActionType {
  type: typeof ACTION.REQUEST_LAYOUT_MODEL;
  payload: {
    instanceKey: string;
  };
}

export interface CaseViewTableReceiveLayoutModelActionType {
  type: typeof ACTION.RECEIVE_LAYOUT_MODEL;
  payload: {
    instanceKey: string;
    layoutModel: FavouriteLayoutModel;
  };
}


export type CaseTableActionType = CaseViewTableResultAppendActionType |
  CaseViewTableResultReplaceActionType | RequestCaseViewTableActionType |
  FailExecuteFavouriteActionType | CaseViewTableClearActionType |
  CaseViewTableRequestRemoveItemActionType | CaseViewTableRemoveItemActionType | 
  CaseViewTableRequestSingleSupplierUrlActionType | CaseViewTableReceiveSingleSupplierUrlActionType |
  CaseViewTableRequestLayoutModelActionType | CaseViewTableReceiveLayoutModelActionType;
